import { put } from '..';

const addSolveTag = (assetId: string, solveTagId: string) => put(
  `assets/${assetId}/solve-tags`,
  { solveTagId },
);

export default addSolveTag;
